import Axios from "axios";
import {
    SET_UPAZILA_LIST,
    UNSET_UPAZILA_LIST,
} from "@/store/mutation-types";
import { getUpazilaList } from "@/store/api";

// initial state
const state = {
    getUpazilaList: [],
};

const getters = {
    getUpazilaList(state) {
        return state.getUpazilaList;
    }
};

const mutations = {
    [SET_UPAZILA_LIST](state, data) {
        state.getUpazilaList = data;
    },
    [UNSET_UPAZILA_LIST](state) {
        state.getUpazilaList = [];
    }
};

const actions = {
    getUpazilaList({ commit }, districtId = null) {
        return new Promise((resolve, reject) => {
            const url = districtId ? `${getUpazilaList}?district_id=${districtId}` : getUpazilaList;
            Axios.get(url)
                .then(function (response) {
                    // Handle different response structures
                    let data = response.data;
                    if (data && data.data) {
                        data = data.data; // If response is wrapped in {data: [...]}
                    }
                    if (!Array.isArray(data)) {
                        data = []; // Ensure it's always an array
                    }
                    commit('SET_UPAZILA_LIST', data);
                    resolve(response);
                })
                .catch(function (error) {
                    console.error('Error loading upazilas:', error);
                    commit('UNSET_UPAZILA_LIST');
                    reject(error);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
